import React from 'react';
import Icon from '../../../components/AppIcon';


const PaymentTemplateCard = ({ template, language, onEdit, onDelete }) => {
  const totalPercentage = template?.phases?.reduce((sum, phase) => sum + phase?.percentage, 0);

  return (
    <div className="bg-card border border-border rounded-lg p-5 hover:shadow-lg transition-all duration-200">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-foreground mb-1">{template?.name}</h3>
          <p className="text-sm text-muted-foreground">{template?.description}</p>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={() => onEdit(template)}
            className="p-2 hover:bg-muted rounded-lg transition-colors"
            title={language === 'FR' ? 'Modifier' : 'Edit'}
          >
            <Icon name="Edit" size={16} className="text-primary" />
          </button>
          <button
            onClick={() => onDelete(template?.id)}
            className="p-2 hover:bg-muted rounded-lg transition-colors"
            title={language === 'FR' ? 'Supprimer' : 'Delete'}
          >
            <Icon name="Trash2" size={16} className="text-error" />
          </button>
        </div>
      </div>
      <div className="space-y-3 mb-4">
        {template?.phases?.map((phase, index) => (
          <div key={index} className="flex items-center gap-3 bg-muted/30 rounded-lg p-3">
            <div className="flex items-center justify-center w-8 h-8 rounded-full bg-primary/10 text-primary font-semibold text-sm">
              {phase?.phaseNumber}
            </div>
            <div className="flex-1">
              <p className="text-sm font-medium text-foreground">{phase?.phaseName}</p>
              <p className="text-xs text-muted-foreground">
                {language === 'FR' ? 'Jour' : 'Day'} {phase?.daysOffset}
              </p>
            </div>
            <div className="text-right">
              <p className="text-lg font-bold text-primary">{phase?.percentage}%</p>
            </div>
          </div>
        ))}
      </div>
      <div className="flex items-center justify-between pt-4 border-t border-border">
        <div className="flex items-center gap-2">
          <Icon name="CheckCircle" size={16} className={template?.isActive ? 'text-success' : 'text-muted-foreground'} />
          <span className="text-sm text-muted-foreground">
            {template?.isActive 
              ? (language === 'FR' ? 'Actif' : 'Active')
              : (language === 'FR' ? 'Inactif' : 'Inactive')
            }
          </span>
        </div>
        <div className="flex items-center gap-2">
          <Icon name="TrendingUp" size={16} className="text-muted-foreground" />
          <span className="text-sm font-medium text-foreground">
            {template?.usageCount} {language === 'FR' ? 'utilisations' : 'uses'}
          </span>
        </div>
      </div>
      {totalPercentage !== 100 && (
        <div className="mt-3 flex items-center gap-2 p-2 bg-warning/10 border border-warning/30 rounded-lg">
          <Icon name="AlertTriangle" size={14} className="text-warning" />
          <span className="text-xs text-warning">
            {language === 'FR' ? 'Total' : 'Total'}: {totalPercentage?.toFixed(2)}%
          </span>
        </div>
      )}
    </div>
  );
};

export default PaymentTemplateCard;